import React from "react";
import PropTypes from "prop-types";
import withStyles from "@material-ui/core/styles/withStyles";
import { Button } from "@material-ui/core";

const styles = (theme) => ({
  submit: {
    marginTop: theme.spacing() * 3,
  },
});

const FormSubmitButton = (props) => {
  const { classes } = props;

  return (
    <Button
      fullWidth
      variant="contained"
      color="primary"
      type="submit"
      className={classes.submit}
      disabled={props.disabled}
    >
      {props.children}
    </Button>
  );
};

FormSubmitButton.propTypes = {
  classes: PropTypes.object.isRequired,
  disabled: PropTypes.bool,
  children: PropTypes.string.isRequired,
};

export default withStyles(styles)(FormSubmitButton);



// WEBPACK FOOTER //
// ./src/components/forms/FormSubmitButton.js